import React from 'react'

import styles from './index.module.less'
import type { ReactNode } from 'react'

export const EmptySvg: React.FC<{
  size?: number
}> = ({ size = 176 }) => (
  <svg width={size} height={size} viewBox="0 0 201 201" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="100.757" cy="100.215" r="88" fill="#F6F6FA" />
    <g clip-path="url(#clip0_2_117284)" filter="url(#filter0_d_2_117284)">
      <rect x="25.7568" y="43.2148" width="150" height="113.571" rx="4.07143" fill="white" />
      <mask id="mask0_2_117284" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="25" y="43" width="151" height="114">
        <rect x="25.7568" y="43.2148" width="150" height="113.571" rx="4.07143" fill="white" />
      </mask>
      <g mask="url(#mask0_2_117284)">
        <rect x="25.7568" y="43.2148" width="150" height="15" fill="url(#paint0_linear_2_117284)" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M35.3995 50.7149C35.3995 51.8983 34.4401 52.8577 33.2566 52.8577C32.0732 52.8577 31.1138 51.8983 31.1138 50.7149C31.1138 49.5314 32.0732 48.572 33.2566 48.572C34.4401 48.572 35.3995 49.5314 35.3995 50.7149ZM41.8281 50.7149C41.8281 51.8983 40.8687 52.8577 39.6852 52.8577C38.5017 52.8577 37.5424 51.8983 37.5424 50.7149C37.5424 49.5314 38.5017 48.572 39.6852 48.572C40.8687 48.572 41.8281 49.5314 41.8281 50.7149ZM46.1138 52.8577C47.2973 52.8577 48.2567 51.8983 48.2567 50.7149C48.2567 49.5314 47.2973 48.572 46.1138 48.572C44.9303 48.572 43.9709 49.5314 43.9709 50.7149C43.9709 51.8983 44.9303 52.8577 46.1138 52.8577Z"
          fill="white"
        />
        <rect x="39.7568" y="73.2148" width="60" height="60" rx="5.7" fill="#ECEEF5" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M56.3889 95.7905C56.6 94.3126 57.8658 93.2148 59.3587 93.2148H80.1549C81.6479 93.2148 82.9137 94.3126 83.1248 95.7905L86.2677 117.791C86.5258 119.598 85.1235 121.215 83.2978 121.215H56.2159C54.3902 121.215 52.9878 119.598 53.246 117.791L56.3889 95.7905Z"
          fill="url(#paint1_linear_2_117284)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M69.7568 86.2148C66.9036 86.2148 64.7568 88.2967 64.7568 90.6693V96.4823C65.3546 96.8282 65.7568 97.4745 65.7568 98.2148C65.7568 99.3194 64.8614 100.215 63.7568 100.215C62.6523 100.215 61.7568 99.3194 61.7568 98.2148C61.7568 97.4745 62.159 96.8282 62.7568 96.4823V90.6693C62.7568 87.017 65.9827 84.2148 69.7568 84.2148C73.531 84.2148 76.7568 87.017 76.7568 90.6693V96.4823C77.3546 96.8282 77.7568 97.4745 77.7568 98.2148C77.7568 99.3194 76.8614 100.215 75.7568 100.215C74.6523 100.215 73.7568 99.3194 73.7568 98.2148C73.7568 97.4745 74.159 96.8282 74.7568 96.4823V90.6693C74.7568 88.2967 72.6101 86.2148 69.7568 86.2148Z"
          fill="#ABB2C2"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M109.757 79.7148C109.757 78.3341 110.876 77.2148 112.257 77.2148H143.257C144.638 77.2148 145.757 78.3341 145.757 79.7148C145.757 81.0956 144.638 82.2148 143.257 82.2148H112.257C110.876 82.2148 109.757 81.0956 109.757 79.7148ZM109.757 105.715C109.757 104.334 110.876 103.215 112.257 103.215H129.257C130.638 103.215 131.757 104.334 131.757 105.715C131.757 107.096 130.638 108.215 129.257 108.215H112.257C110.876 108.215 109.757 107.096 109.757 105.715ZM112.257 90.2148C110.876 90.2148 109.757 91.3341 109.757 92.7148C109.757 94.0956 110.876 95.2148 112.257 95.2148H157.257C158.638 95.2148 159.757 94.0956 159.757 92.7148C159.757 91.3341 158.638 90.2148 157.257 90.2148H112.257Z"
          fill="#ECEEF5"
        />
      </g>
    </g>
    <defs>
      <filter id="filter0_d_2_117284" x="5.75684" y="29.2148" width="190" height="154" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="6" />
        <feGaussianBlur stdDeviation="10" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.32549 0 0 0 0 0.352941 0 0 0 0 0.384314 0 0 0 0.14 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2_117284" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2_117284" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_2_117284" x1="25.8142" y1="43.2263" x2="25.8142" y2="58.2148" gradientUnits="userSpaceOnUse">
        <stop stop-color="#D2D8E4" />
        <stop offset="1" stop-color="#B8BECC" />
      </linearGradient>
      <linearGradient id="paint1_linear_2_117284" x1="52.7698" y1="93.2362" x2="52.7698" y2="121.215" gradientUnits="userSpaceOnUse">
        <stop stop-color="#D2D8E4" />
        <stop offset="1" stop-color="#B8BECC" />
      </linearGradient>
      <clipPath id="clip0_2_117284">
        <rect width="150" height="114" fill="white" transform="translate(25.7568 43.2148)" />
      </clipPath>
    </defs>
  </svg>
)

interface EmptyProps {
  text?: ReactNode
  className?: string
  textStyle?: any
  style?: React.CSSProperties
  imgStyle?: React.CSSProperties
}

const Empty: React.FC<EmptyProps> = (props) => {
  const { text, textStyle, className, style, imgStyle } = props
  return (
    <div className={className} style={{ textAlign: 'center', ...style }}>
      <div className={styles.img} style={{ width: 108, marginTop: 61, ...imgStyle }} />
      <p style={{ fontSize: 16, color: '#666666', fontWeight: 600, ...textStyle }}>{text}</p>
    </div>
  )
}

export default Empty
